import React, { memo, PropsWithChildren } from 'react'

import { introspectionResult } from '@affiliate-cabinet/graphql'
import { resolveDomain } from '@affiliate-cabinet/rest'
import { ApolloClient, ApolloProvider, createHttpLink, from, InMemoryCache } from '@apollo/client'

import { apolloErrorLink } from '../../shared/utils/apolloErrorLink'

const uri = `${resolveDomain()}/api/graphql`

const httpLink = createHttpLink({
  credentials: 'include',
  uri,
})

const gqlClient = new ApolloClient({
  cache: new InMemoryCache({
    possibleTypes: introspectionResult.possibleTypes,
  }),
  link: from([apolloErrorLink, httpLink]),
  uri,
})

export const AppApolloProvider = memo(({ children }: PropsWithChildren) => <ApolloProvider client={gqlClient}>{children}</ApolloProvider>)
AppApolloProvider.displayName = 'AppApolloProvider'
